import React from 'react'
import Modal from 'modals/dialog'
import Details from './details'
import { fallbackSymbol } from 'pages/meetings/constants'

const PreviewTemplate = ({ name, description, symbol, agenda, salt, ...props }) => (
    <>
        <Modal.Header
            symbol={{
                symbol: symbol ?? fallbackSymbol,
                size: 56
            }}
            heading={name}
            headingClassName="serif" />
        <Modal.Body>
            <Details
                {...props}
                description={description}
                agenda={agenda}
                salt={salt} />
        </Modal.Body>
    </>
)

export default PreviewTemplate
